import { Concorrente } from "../../types/concorrenti/concorrente";
import { Gara } from "../../types/gare/gara";
import PartecipantiIndividualiTab from "./PartecipantiIndividualiTab";
import PartecipantiCoppieTab from "./PartecipantiCoppieTab";
import PartecipantiBoxTab from "./PartecipantiBoxTab";

interface GaraPartecipantiTabProps {
  typeId: number;
  gara: Gara;
  onOpenResults?: () => void;
  pendingCompetitors?: Concorrente[];
  onStageCompetitor?: (competitor: Concorrente) => void;
  onCancelCompetitor?: (id: number) => void;
}

const GaraPartecipantiTab: React.FC<GaraPartecipantiTabProps> = ({ typeId, gara, onOpenResults, pendingCompetitors, onStageCompetitor, onCancelCompetitor }) => {
  switch (typeId) {
    case 1:
      return <PartecipantiIndividualiTab gara={gara} onOpenResults={onOpenResults} pendingCompetitors={pendingCompetitors} onStageCompetitor={onStageCompetitor} onCancelCompetitor={onCancelCompetitor} />;
    case 2:
      return <PartecipantiCoppieTab gara={gara}/>;
    case 3:
      return <PartecipantiBoxTab gara={gara}/>;
    default:
      return <div>Tipo gara non supportato</div>;
  }
};

export default GaraPartecipantiTab;
